export const overviewFieldLabels = {
  businessName: "Customer Name",
  emailAddress: "Email",
  phoneNumber: "Phone",
  AssignedTo: "Assigned User",
  defaultTax: "Default Tax",
  terms: "Payment Terms",
  defaultCurrency: "Default Currency",
  industry: "Industry",
};

export const getOverviewSaveErrors = (error) => {
  const data = error?.response?.data;
  const errors = data?.errors || data?.validationErrors;
  const messages = [];
  const addMessage = (message, field) => {
    if (message == null || typeof message === "object") return;
    const text = String(message).trim();
    if (!text) return;
    const label = overviewFieldLabels[field] || field;
    messages.push(
      label && !text.toLowerCase().startsWith(String(label).toLowerCase())
        ? `${label}: ${text}`
        : text,
    );
  };

  if (Array.isArray(errors)) {
    errors.forEach((item) => {
      if (typeof item === "string") addMessage(item);
      else {
        addMessage(
          item?.message || item?.msg || item?.error,
          item?.field || item?.path || item?.param,
        );
      }
    });
  } else if (errors && typeof errors === "object") {
    Object.entries(errors).forEach(([field, value]) => {
      (Array.isArray(value) ? value : [value]).forEach((item) =>
        addMessage(item?.message || item?.msg || item, field),
      );
    });
  }

  addMessage(typeof data?.message === "string" ? data.message : null);
  addMessage(typeof data?.error === "string" ? data.error : null);
  return [
    ...new Set(
      messages.length
        ? messages
        : ["Please review the form and try again."],
    ),
  ];
};
